import type { ServerEnvConfigType } from '@/shared/config/ServerEnvConfigType';
import type { DocsSiteVisitType } from '@/shared/constant/DocsIdTypeData';
import { OnlineType } from '@/shared/constant/OnlineType';
import type { LocaleType } from '@/shared/i18n/i18n';
import { clientRequest } from '@/shared/request/clientRequest.client';

export type RequestDocsSiteExportDataType = {
  type: string;
  id: string;
  projectId?: string | number;
  version?: string;
  excludeExtension?: boolean;
  excludeTagsWithFolder?: boolean;
  branchId?: number;
};

export async function requestDocsSiteExport(
  requestData: RequestDocsSiteExportDataType,
  onlineType: OnlineType,
  envConfig: ServerEnvConfigType,
  clientI18n: (key: keyof LocaleType, params?: Record<string, string>) => string,
  visitType?: DocsSiteVisitType,
  subdirectory?: string,
) {
  const url = (() => {
    if (onlineType === OnlineType.SharedDoc) {
      return `/api/v1/projects/${requestData.projectId}/shared-docs/${requestData.id}/export-data`;
    }

    return `/api/v1/projects/${requestData.id}/published-projects/export-data?branchId=${requestData.branchId}`;
  })();

  return await clientRequest<Response>(
    url,
    {
      responseType: 'blob',
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
      },
      projectId: Number(requestData.projectId || 0),
      body: JSON.stringify(requestData),
      envConfig,
      visitType,
      subdirectory,
    },
    clientI18n,
  );
}
